<!--
 * @Author: wangjiaxiang
 * @Date: 2022-04-06 10:36:46
 * @LastEditTime: 2022-04-22 17:07:27
 * @LastEditors: wangjiaxiang
 * @Description:
 * @FilePath: /xingmahui_front/src/views/contents/expertsView/index.vue
 *
-->
<template>
  <div>
    <keep-alive :include="includes" :max="10">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<style lang="less" scoped></style>

<script>
import { mapState } from "vuex";

export default {
  name: "expertsViewIndex",
  components: {},
  data() {
    return {};
  },
  computed: {
    // 在computed中动态监控
    ...mapState({
      includes: (state) => state.includes,
    }),
  },
  mounted() {

  },
  created() {},
  methods: {},
};
</script>
